import confetti from 'canvas-confetti';

export class ConfettiSystem {
    constructor() {
        this.defaults = {
            startVelocity: 30,
            spread: 360,
            ticks: 60,
            zIndex: 2000
        };
    }

    playVictoryConfetti() {
        this.stop(); // Clear any existing interval

        const duration = 3000;
        const animationEnd = Date.now() + duration;
        const random = (min, max) => Math.random() * (max - min) + min;

        this.interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return this.stop();
            }

            const particleCount = 50 * (timeLeft / duration);
            
            // Randomly generate confetti from two points
            confetti({
                ...this.defaults,
                particleCount,
                origin: { x: random(0.1, 0.3), y: Math.random() - 0.2 }
            });
            confetti({
                ...this.defaults,
                particleCount,
                origin: { x: random(0.7, 0.9), y: Math.random() - 0.2 }
            });
        }, 250);

        // Final burst
        this.timeout = setTimeout(() => {
            this.fireBurst(0.5, 0.5);
        }, duration - 500);
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        confetti.reset();
    }

    fireBurst(x, y) {
        confetti({
            ...this.defaults,
            particleCount: 100,
            origin: { x, y }
        });
    }
}
